/* Nareva Home — interacciones de la portada (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.nrv-reveal:not(.nrv-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nrv-visible'); });
      return;
    }
    if (!window.__nrvObserver) {
      window.__nrvObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('nrv-visible');
            window.__nrvObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { window.__nrvObserver.observe(el); });
  }

  function initColores(root) {
    (root || document).querySelectorAll('[data-nrv-colores]').forEach(function (sec) {
      if (sec.dataset.nrvReady) return;
      sec.dataset.nrvReady = '1';
      var swatches = sec.querySelectorAll('.nrv-swatch');
      var imgs = sec.querySelectorAll('.nrv-colores__stage .nrv-img');
      var nameEl = sec.querySelector('[data-nrv-name]');
      var textEl = sec.querySelector('[data-nrv-text]');
      var numEl = sec.querySelector('[data-nrv-num]');
      var idInput = sec.querySelector('input[name="id"]');
      var link = sec.querySelector('[data-nrv-link]');
      var fade = sec.querySelector('.nrv-colores__fade');

      swatches.forEach(function (sw, i) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
          sw.setAttribute('aria-pressed', 'true');
          imgs.forEach(function (img, j) { img.classList.toggle('is-active', j === i); });
          if (numEl) numEl.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(swatches.length).padStart(2, '0');
          if (idInput && sw.dataset.variant) idInput.value = sw.dataset.variant;
          if (link && sw.dataset.url) link.setAttribute('href', sw.dataset.url);
          var apply = function () {
            if (nameEl) nameEl.textContent = sw.dataset.name || '';
            if (textEl) textEl.textContent = sw.dataset.text || '';
            if (fade) fade.classList.remove('is-changing');
          };
          if (fade && !reduceMotion) { fade.classList.add('is-changing'); setTimeout(apply, 220); } else { apply(); }
        });
      });
    });
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('[data-nrv-galeria]').forEach(function (sec) {
      if (sec.dataset.nrvReady) return;
      sec.dataset.nrvReady = '1';
      var track = sec.querySelector('.nrv-galeria__track');
      if (!track) return;
      var step = function () {
        var card = track.querySelector('.nrv-galeria__card');
        return card ? card.getBoundingClientRect().width + 18 : 300;
      };
      var prev = sec.querySelector('[data-nrv-prev]');
      var next = sec.querySelector('[data-nrv-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    });
  }

  function initAll(root) {
    initReveals(root);
    initColores(root);
    initGaleria(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Editor de Shopify: re-inicializar al añadir o cambiar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
